// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/state-in-constructor, multiline-comment-style, react/destructuring-assignment, react/sort-comp */
import * as React from "react"
import { connect } from "react-redux"
import classnames from "classnames"
import Portal from "@kiwicom/orbit-components/lib/Portal"

import throttle from "../../utils/throttle"
import { getWidth } from "../../../../app/scripts/tools/windowBindings"
import { getLanguageInfo } from "../../services/staticData"

const DEFAULT_ELEMENT_ID = "detached"
const ANIMATED_STYLE_PROPS = ["opacity", "background"]

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
type Style = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}

type Connect = {
  isRtl: boolean
}

type Props = Connect & {
  children: React.ReactNode
  elementID?: string
  zIndex?: number | string
  className?: string
  preservePosition?: boolean
  animated?: boolean
  style?: Style
  dataTest?: string
  key?: string
}

type State = {
  style: Style
}

const getAnimatedStyle = ({ animated, style }: Props) =>
  animated
    ? {
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        opacity: style && style.opacity,
        background: "rgba(0, 0, 0, .5)",
      }
    : {}

class MoveToBody extends React.PureComponent<Props, State> {
  static defaultProps = {
    elementID: DEFAULT_ELEMENT_ID,
    className: "",
  }

  constructor(props: Props) {
    super(props)

    if (typeof window !== "undefined") {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      const elementID = props.elementID || DEFAULT_ELEMENT_ID // flow is stupid
      const node = document.getElementById(elementID)

      if (!node) {
        const newNode = document.createElement("div")
        newNode.setAttribute("id", elementID)

        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (document.body) {
          document.body.appendChild(newNode)
        }
      }
    }

    this.state = {
      style: this.getStyle(),
    }
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    const { style } = state

    const newAnimatedStyle = getAnimatedStyle(props)
    // @ts-expect-error: Flow to TS migration.
    const styleChanged = ANIMATED_STYLE_PROPS.some((p) => style[p] !== newAnimatedStyle[p])

    if (!styleChanged) {
      return null
    }

    return {
      /* $FlowFixMe This comment suppresses an error found when upgrading Flow
       * to v0.118.0. To view the error, delete this comment and run Flow. */
      style: { ...style, ...newAnimatedStyle },
    }
  }

  componentDidMount() {
    if (this.props.preservePosition) {
      window.addEventListener("scroll", this.updatePosition)
      window.addEventListener("resize", this.updatePosition)

      const libraryEl = document.getElementById("library")

      if (libraryEl) {
        libraryEl.addEventListener("scroll", this.updatePosition)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updatePosition)
    window.removeEventListener("resize", this.updatePosition)

    const libraryEl = document.getElementById("library")

    if (libraryEl) {
      libraryEl.removeEventListener("scroll", this.updatePosition)
    }
  }

  getStyle = () => ({
    /* $FlowFixMe This comment suppresses an error found when upgrading Flow to
     * v0.118.0. To view the error, delete this comment and run Flow. */
    ...this.getPositionStyle(),
    ...getAnimatedStyle(this.props),
  })

  getPositionStyle = () => {
    const { preservePosition, isRtl } = this.props
    const { placeholderRef } = this

    if (!preservePosition || !placeholderRef || !(placeholderRef instanceof HTMLDivElement)) {
      return {}
    }

    const rect = placeholderRef.getBoundingClientRect()

    return {
      position: "absolute",
      top: rect.top,
      ...(isRtl ? { right: getWidth() - rect.left } : { left: rect.left }),
    }
  }

  storePlaceholderRef = (el?: HTMLDivElement | null) => {
    const changed = el !== this.placeholderRef

    this.placeholderRef = el

    if (changed) {
      this.setState({ style: this.getStyle() })
    }
  }

  // FIXME: sort methods in React components according to conventions

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  updatePosition: () => void = throttle(10, () => {
    this.setState({ style: this.getStyle() })
  })

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  placeholderRef: HTMLDivElement | null | undefined = null

  render() {
    const {
      elementID,
      dataTest,
      className,
      animated,
      children,
      key,
      style: propsStyle,
    } = this.props
    const { style } = this.state

    return (
      typeof window !== "undefined" && (
        <>
          <div
            className="MoveToBody"
            style={{ position: "absolute", left: 0 }}
            ref={this.storePlaceholderRef}
            key={key}
          />
          <Portal renderInto={elementID}>
            <div
              className={classnames(className, "spBodyElement", { _animated: animated })}
              // Fix this the next time the file is edited. (Flow to TS)
              // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
              style={{ zIndex: propsStyle && propsStyle.zIndex }}
            >
              <div style={style} className="spBodyElement-inner" data-test={dataTest}>
                {children}
              </div>
            </div>
          </Portal>
        </>
      )
    )
  }
}

export default connect((state) => ({
  // @ts-expect-error: Flow to TS migration.
  isRtl: getLanguageInfo(state).direction === "rtl",
}))(MoveToBody)
